import { useEffect, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../services/firebase.config";
import dataCache from "../../services/DataCache";

export const useProfileData = (userId) => {
  const [profileLoaded, setProfileLoaded] = useState(false);
  const [username, setUsername] = useState("");
  const [photoURL, setPhotoURL] = useState("");
  const [displayName, setDisplayName] = useState("");
  const [quizScore, setQuizScore] = useState(0);
  const [friendsCount, setFriendsCount] = useState(0);
  const [profileData, setProfileData] = useState(null);

  useEffect(() => {
    const fetchProfileData = async () => {
      if (!userId) {
        setProfileLoaded(true);
        return;
      }

      try {
        let cachedProfile = dataCache.getUserProfile(userId);

        if (!cachedProfile) {
          const profileDocRef = doc(db, "public-profiles", userId);
          const profileDoc = await getDoc(profileDocRef);
          if (profileDoc.exists()) {
            cachedProfile = profileDoc.data();
            dataCache.setUserProfile(userId, cachedProfile);
          }
        }

        if (cachedProfile) {
          setUsername(cachedProfile.username || "");
          setPhotoURL(cachedProfile.photoURL || "");
          setDisplayName(cachedProfile.displayName || "");
          setQuizScore(
            Array.isArray(cachedProfile.shared)
              ? cachedProfile.shared.length
              : 0
          );
          setFriendsCount(
            Array.isArray(cachedProfile.friends)
              ? cachedProfile.friends.length
              : 0
          );
          setProfileData(cachedProfile);
        }
      } catch (_) {
      } finally {
        setProfileLoaded(true);
      }
    };

    fetchProfileData();
  }, [userId]);

  return {
    profileLoaded,
    username,
    photoURL,
    displayName,
    quizScore,
    friendsCount,
    profileData,
  };
};
